import axios from "axios";
import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const DesignationModal = ({ show, onClose, onAddSize }) => {
  const [newDesignation, setNewDesignation] = React.useState({  name: ""  });

    const handleSubmit = async () => {
    const payload = {
      name: newDesignation.name,
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_URL}/add-designation`, payload);
        onAddSize({ value: response?.data?.data?.name, label: response?.data?.data?.name });

        // Clear the form
        setNewDesignation({ name: "" });
        onClose();
    } catch (error) {
      console.error("Error adding designation:", error);
      // You can show a toast or alert here
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add Designation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label style={{ color: "black" }}>Name</Form.Label>
            <Form.Control
              type="text"
              value={newDesignation.name}
              onChange={(e) =>
                setNewDesignation({ ...newDesignation, name: e.target.value })
              }
              placeholder="Enter designation name"
            />
            </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Add Designation
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DesignationModal;
